import './FeaturedCoursesSection.less';
import React, {useState, useEffect} from 'react';
import Request from "../../../../bootstrap/api/Request";
import CourseListParcel from "../../../api/endpoints/course/CourseListParcel";
import Toasts, {TOAST_ERROR} from "../../../../bootstrap/scomponents/toasts/Toasts";
import TitledSection from "../../../components/titled-section/TitledSection";
import __ from "../../../i18n";
import Spinner from "../../../../bootstrap/components/spinner/Spinner";
import CourseItemCard from "../../../widgets/course-item-card/CourseItemCard";
import GridView from "../../../components/grid-view/GridView";
import {GRID_VIEW_SIZE_MEDIUM} from "../../../view-constants/listing";
import Button from '../../../../bootstrap/components/button/Button';


export default function FeaturedCoursesSection({}) {
    const [viewData, setViewData] = useState({
        courses: [],
        refs: {
            creators: [],
            images: [],
            promotions: [],
        },
        total: 0,
    });

    const [page, setPage] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);

        const orders = [
            {key: 'priority', isAsc: false},
            {key: 'id', isAsc: false}
        ];

        const limit = GRID_VIEW_SIZE_MEDIUM;

        const offset = page * GRID_VIEW_SIZE_MEDIUM;

        const refNames = ['image', 'user', 'promotion'];

        Request.add(new CourseListParcel({orders, limit, offset, refNames}))
            .then(data => {
                setViewData((viewData) => ({
                    courses: viewData.courses.concat(data.items),
                    refs: {
                        creators: viewData.refs.creators.concat(data.refs.users),
                        images: viewData.refs.images.concat(data.refs.images),
                        promotions: viewData.refs.promotions.concat(data.refs.promotions),
                    },
                    total: data.total,
                }));
            })
            .catch(error => {
                Toasts.add(TOAST_ERROR, error.getMessage());
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [page]);

    const showsSeeMoreButton = !isLoading && GRID_VIEW_SIZE_MEDIUM * (page + 1) < viewData.total;

    return <div className="featured-courses-section">
        <TitledSection
            title={__('home_course_section_title')}
            description={__('home_course_section_description')}
        >
            {
                viewData !== null > 0 &&
                <GridView density="medium">
                    {
                        viewData.courses.map(item => {
                            return <CourseItemCard
                                key={item.id}
                                course={item}
                                creator={viewData.refs.creators.find(t => t.id === item.creator_id)}
                                avatarImage={viewData.refs.images.find(t => t.id === item.avatar_image_id)}
                                promotionalAvatarImage={viewData.refs.images.find(t => t.id === item.promotional_avatar_image_id)}
                                promotion={viewData.refs.promotions.find(t => t.id === item.promotion_id)}
                            />;
                        })
                    }
                </GridView>
            }
            {
                <div className="section-bottom">
                    {
                        isLoading &&
                        <Spinner size={2.5} />
                    }
                    {
                        showsSeeMoreButton && <Button
                            title={__('See more')}
                            onClick={() => setPage(currentPage => currentPage + 1)}
                        />
                    }
                </div>
            }
        </TitledSection>
    </div>;
}
